import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { loginSuccess, apiError } from "./actions"

import axios from "axios"
const {REACT_APP_API_PROXY_BASE_URL} = process.env;
import * as url from "../../../helpers/url_helper"

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield axios.get(REACT_APP_API_PROXY_BASE_URL + url.POST_LOGIN + "?username="+user.username+"&password="+user.password)
    localStorage.setItem("authUser", JSON.stringify(response.data))
    yield put(loginSuccess(response))
    history.push("/espaceagent")
  } catch (error) {
    if (error.response != undefined) {
      yield put(apiError(error.response.data))  
    } else {
      yield put(apiError(error.message)) 
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    history.push("/login")
  } catch (error) {
    yield put(apiError(error.response.data))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
